import React from 'react'
import Title from './Title'
import Pdf from '../icons/mynewCV.pdf'

function Skill() {
  return (
    <div>
      <div className="container">
        <div className="row border my-3">
          <Title title="Education Details" />
          <p>10th Passed from WBBSE</p>
          <p>12th science passed from WBCHSE</p>
          <p>ITI in computer operator and programming assistant passed from NCVT</p>
          <p>Bsc(Hons) in Computer Science passed from Calcutta University</p>
          <p>Btech in Computer Science and Engineering pursuing from Calcutta University</p>
        </div>
        <div className="row border my-3">
          <Title title="Technical Skill" />
          <p>C</p>
          <p>JAVA(CORE JAVA
            ,servlet,jsp )</p>
          <p> PYTHON</p>
          <p>WEB DEVELOPMENT(Full Stack)</p>
          <p>GITHUB </p>
          <p>DBMS </p>
          <p>DATA STRUCTURE </p>
          <p>React JS </p>
          <p>Express JS </p>
          <p>Mongoose</p>
          <p>MERN Stack</p>
        </div>
        <div className="row border my-3">
        <Title title="Project Experience" />
        <p>Lead one project of IBM CSIRBOX internship</p>
        <p>Lead Bsc final year project on college management system</p>
        </div>
        <div className="row border my-3">
        <Title title="Resume" />
            <p>I attached my resume <a href={Pdf} target="_blank" rel="noopener noreferrer">here</a></p>
        </div>
      </div>


    </div>
  )
}

export default Skill
